import * as Yup from "yup";

export const CustomerFormSchema = Yup.object({
  clientId: Yup.string().required("Client ID can not be blank"),
  first_name: Yup.string().required("Customer first name can not be blank"),

  last_name: Yup.string().required("Customer last name can not be blank"),
  email: Yup.string()
    .email("Invalid Email")
    .required("Customer email can not be blank"),
  phone: Yup.string()
    .min(10, "Phone no is invalid")
    .required("Customer phone number can not be blank"),
  isActive: Yup.string().required("Customer status can not be blank"),
});
